'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { StyledActionGroup } from './elements';
export const ActionGroup = ({
  alignment = 'left',
  direction = 'row',
  ...rest
}) => /*#__PURE__*/React.createElement(StyledActionGroup, _extends({
  "data-aui": "action-group",
  $alignment: alignment,
  $direction: direction
}, rest));